module.exports = __webpack_public_path__ + "img/fouth.dd371a46.png";